import React from 'react'
import ReactDOM from 'react-dom'
import InfoWindowBox from '../../components/MapAssetLoader/InfoWindowBox'
import OutsideAlerter from '../OutsideClicker'

const reverseGeocode = async marker => new Promise((resolve, reject) => {
  const geocoder = new window.google.maps.Geocoder()
  geocoder.geocode(
    { location: marker.getPosition() },
    (results, status) => {
      if (status === 'OK') {
        const match = results.find(({ geometry: { location_type } }) => location_type === 'ROOFTOP')
        if (match) {
          resolve(match.formatted_address)
        } else {
          reject('No results found')
        }
      } else {
        reject(`Geocoder failure - status: ${status}`)
      }
    }
  )
})

const Adhoc = (map, marker, nestModal, setAsset, onclickOpen) => {

  let infoWindow = new window.google.maps.InfoWindow()

  const markerStatus = 4

  const onclickOpenModal = (value) => {
    infoWindow.close()
    marker.setMap(null)
    onclickOpen(value)
  }

  const closeInfoWindow = () => {
    if (marker.open) {
      infoWindow.close()
      marker.setMap(null)
      marker.open = false
    }
  }

  const asset = { address: null, poleNumber: null, status: 'Adhoc' }
  
  const setAddress = async (marker) => {
    const addressGeoCode = await reverseGeocode(marker)       
    asset.address = addressGeoCode
    setAsset(asset)
  }
  
  if(marker) {
    setAddress(marker)
  }
  let div = document.createElement("div")
  div.setAttribute("id", "popupContainer")
  
  ReactDOM.render(
    <OutsideAlerter eventListener='click' onClickOutside={closeInfoWindow}>
      <InfoWindowBox
        closeInfoWindow = {closeInfoWindow}
        markerColorCode={markerStatus}
        asset={asset}
        nestModal={nestModal}
        onclickOpen={onclickOpenModal}
      />
    </OutsideAlerter>
    , div
  )
  infoWindow.setContent(div)
  infoWindow.open(map, marker)
  marker.open = true
}

export default Adhoc